import React, { useState, useEffect, useRef, useCallback } from 'react';
import { MdAdd } from 'react-icons/md';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function MensagemEdit({ match }) {
  const inputRef = useRef(null);
  const [dado, setDado] = useState([]);
  const [dadoMensagem, setDadoMensagem] = useState([]);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(true);

  const getDados = useCallback(async () => {
    const { id } = match.params;
    const response = await api.get(`/whatsapp/${id}`);
    const { mensagem } = response.data;
    const dataMensagem = mensagem.map(men => {
      return {
        id: men.id,
        feriado: men.feriado === '1' ? 'Sim' : 'Não',
        depois_horario: men.depois_horario === '1' ? 'Sim' : 'Não',
        mensagem: men.mensagem,
      };
    });

    setDado(response.data);
    setDadoMensagem(dataMensagem);
    setLoading(false);
  }, [match.params]);

  useEffect(() => {
    getDados();
  }, [getDados, match.params]);

  // Buscando os dados da api

  async function handlerSubmit(data, { reset }) {
    try {
      setCarregar(true);
      const { id } = match.params;
      inputRef.current.setErrors({});

      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/whatsapp/${id}`, {
        name: data.name,
      });

      toast.success('Integração editada com sucesso');

      reset();
      history.push(`/mensagem`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao editar integração verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'feriado',
      label: 'Feriado',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'depois_horario',
      label: 'Depois do expediente',
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: 'mensagem',
      label: 'Mensagem',
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  async function handlerEditar(number) {
    const { id } = match.params;
    history.push(`/whatsapp/${id}/mensagem/${number}`);
  }

  async function handlerStatus(number) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(
            `/whatsapp/${dado.id}/mensagens/${num}`
          );
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Mensagem excluida com sucesso');
            getDados();
          }
        });
      } else {
        const response = await api.delete(
          `/whatsapp/${dado.id}/mensagens/${number}`
        );

        if (response.data) {
          toast.success('Mensagem excluida com sucesso');
          getDados();
        }
      }
    } catch (error) {
      toast.error('Erro ao ativar/desativar produto');
    } finally {
      setLoading(false);
    }
  }

  function handleCreate() {
    history.push(`/whatsapp/${dado.id}/mensagem-edit`);
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Editar Integração de Mensagem</h4>
      <Card>
        <Form
          initialData={dado}
          ref={inputRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
        >
          <Input
            icon="MdMail"
            name="name"
            label="Nome da integração de mensagem"
            type="text"
          />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
      <h3>Mensagens</h3>
      <Card>
        <Menus>
          <NewButton onClick={handleCreate}>
            <MdAdd size={16} color="#FFF" />
            Novo
          </NewButton>
        </Menus>
        <Table
          title="Integrações"
          data={dadoMensagem}
          columns={columns}
          ds={handlerStatus}
          ed={handlerEditar}
          messages="Você deseja excluir mensagem?"
          dw
          st
        />
      </Card>
    </Container>
  );
}

MensagemEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
